import React, { useEffect, useState } from 'react';
import { apiFetch } from '../api';
import SurveyDetail from './SurveyDetail';

export default function AdminSurveys() {
  const [items, setItems] = useState([]);
  const [err, setErr]     = useState('');
  const [loading, setLoading] = useState(false);
  const [active, setActive]   = useState(null);

  useEffect(()=>{
    (async ()=>{
      try{
        setLoading(true); setErr('');
       const res = await apiFetch('admin/surveys_list.php');
        const js  = await res.json();
        if(!js.ok) throw new Error(js.error || 'Fehler');
        setItems(js.items || []);
      }catch(e){ setErr(e.message || 'Laden fehlgeschlagen'); }
      finally{ setLoading(false); }
    })();
  },[]);

  if (active) {
    return <SurveyDetail slug={active} onBack={()=>setActive(null)} />;
  }

  return (
    <div>
      <h2>Umfragen</h2>
      {err && <div className="card" style={{color:'crimson',borderColor:'crimson'}}>{err}</div>}
      {loading && <div className="card">Lade…</div>}
      <div className="grid" style={{display:'grid', gap:'1rem', gridTemplateColumns:'repeat(auto-fill, minmax(260px, 1fr))'}}>
        {(items||[]).map(item=>(
          <div key={item.slug} className="card" style={{cursor:'pointer'}} onClick={()=>setActive(item.slug)}>
            <div style={{fontSize:14, opacity:.7}}>Slug</div>
            <div style={{fontWeight:700, fontSize:18, marginBottom:6}}>{item.slug}</div>
            <div style={{display:'flex', justifyContent:'space-between', fontSize:14}}>
              <span>Teilnahmen</span><strong>{item.responses}</strong>
            </div>
            <div style={{marginTop:8, fontSize:12, opacity:.7}}>
              {item.first_at} – {item.last_at}
            </div>
          </div>
        ))}
        {(items||[]).length===0 && !loading && !err && (
          <div className="card">Noch keine Einträge.</div>
        )}
      </div>
    </div>
  );
}
